import { render } from "./IconSave.vue?vue&type=template&id=54f98aee"
import script from "./IconSave.vue?vue&type=script&lang=js"
export * from "./IconSave.vue?vue&type=script&lang=js"
script.render = render

export default script